import { SelectedOrderDetailsUi } from '@/components/Order/GlobalOrders/GlobalOrdersUi';
import { OrderDetailResponse } from '@/data/api/model/orders/globalOrdersDto';
import { getStatusBadge } from '../useGetDetailOrders/mapper';

export function orderDetailResponseToSelectedOrderDetails(
  details: OrderDetailResponse[]
): SelectedOrderDetailsUi[] {
  return details.map((detail) => ({
    orderId: detail.order_detail_id,
    orderNumber: detail.order_detail_number,
    sellerName: detail.seller_name,
    sellerImage: detail.sellerImage,
    totalOrderAmount: detail.total_order_detail_amount.toString(),
    productQuantity: detail.item_count.toString(),
    badge: getStatusBadge(detail.order_detail_status),
  }));
}
